<!-- ═══════════════ MODAL: LAUNCHPAD COMMIT FUNDS (NEW) ═══════════════ -->
@if (state.showLaunchpadModal() && state.selectedLaunchpadProject()) {
<div class="modal-overlay" (click)="state.closeLaunchpadModal()">
  <div class="modal-panel animate-slide-up" (click)="$event.stopPropagation()">
    <button (click)="state.closeLaunchpadModal()"
      class="absolute top-5.5 right-5.5 text-text-dim hover:text-white transition-colors text-lg">✕</button>

    <h3 class="font-display font-black text-2xl text-white tracking-wide mb-1">Commit Capital Funds</h3>
    <p class="text-[11.5px] text-text-dim uppercase tracking-wider font-semibold mb-5">Participate in {{
      state.selectedLaunchpadProject()?.name }} Launch</p>

    <div
      class="bg-white/[0.02] border border-border-primary rounded-2xl p-4.5 mb-5 flex flex-col gap-3.5 text-xs text-text-muted">
      <div class="flex justify-between">
        <span>Target Pool Max</span>
        <span class="font-bold text-white">{{ state.selectedLaunchpadProject()?.target }} BNB</span>
      </div>
      <div class="flex justify-between">
        <span>Launch Price Ratio</span>
        <span class="font-bold text-gold">{{ state.selectedLaunchpadProject()?.ratio }}</span>
      </div>
    </div>

    <div
      class="bg-black/45 border border-border-primary focus-within:border-gold/20 rounded-2xl p-4.5 mb-6 transition-all">
      <div
        class="flex items-center justify-between text-[11px] font-bold text-text-dim uppercase tracking-wider mb-2">
        <span>Amount to Commit</span>
        <span>Wallet Balance: {{ state.walletBalance().toFixed(3) }} BNB</span>
      </div>
      <div class="flex items-center justify-between gap-4">
        <input type="text" placeholder="0.00" [value]="state.commitLaunchpadAmount()"
          (input)="state.commitLaunchpadAmount.set($any($event.target).value)" class="swap-input text-2xl" />
        <span class="font-black text-white text-[13.5px] tracking-widest uppercase">BNB</span>
      </div>
    </div>

    <button (click)="state.executeLaunchpadCommit()"
      class="btn-gold w-full py-4 rounded-xl text-[13px] font-bold tracking-widest uppercase shadow-md">
      Commit Capital Assets
    </button>
  </div>
</div>
}
